import ConstList from '../../ConstList'

/*
 * 休暇申請を、承認待ち・承認済みのあとで取り消したいとき（束5、2026-09-30。文は 2026-10-09 に決めた）。
 *
 * 前は状態を見ずに［削除］［編集］を出していた。押すと「承認済みの休暇申請は
 * 削除できません。」などと断られ、どうすれば取り消せるかは画面のどこにも無かった。
 *
 * - 承認待ち：本人が［自分の申請一覧］の［申請取消］で未申請に戻せる
 *   （back の applyCancelSubmissionPlil。承認待ちのときだけ通る）
 * - 承認済み：一覧を開ける人（経営管理者・事務担当者など）が［承認取消］で承認待ちに
 *   戻し、そのあと本人が［申請取消］する
 *
 * 未申請・差戻しなら、これまでどおり［削除］［編集］ができる。
 */
const GUIDES = {
  [ConstList.APPROVAL_PENDING]:
    '「自分の申請一覧」で［申請取消］を行うと未申請に戻り、編集・削除ができます。',
  [ConstList.APPROVAL]:
    '担当者等に［承認取消］を依頼して承認待ちに戻し、「自分の申請一覧」で［申請取消］を行うと未申請に戻り、編集・削除ができます。'
}

/** この状態の休暇申請を、本人が削除・編集できるか。 */
export function leaveIsEditable (status) {
  return !Object.prototype.hasOwnProperty.call(GUIDES, status)
}

/** 削除・編集できない状態のときの、取り消し方の1行。できる状態なら空。 */
export function leaveCancelGuide (status) {
  return GUIDES[status] || ''
}
